export default __webpack_public_path__ + "static/media/logout.95324ff8.svg";